import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.activity',
    modules: [
        R,
    ],
})
@Service('ActivityStore')
export default class Store{
    constructor ($q, R) {
        "ngInject";
        this.$q = $q;
        this.R = R;
    }

    getNew (object) {
        let store = new BaseStore(this.$q, this.R);
        store.endpoint = object.all('activity');
        return store;
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/activity.js